<template>
    <div class="row">
        <div class="col-12">
            <div class="form-group mb-2">
                <small class="input-title">Tipo de cuenta</small>
                <v-select v-model="data.account_type"
                    :items="accounts"
                    hide-details
                    class="form-control form-control-sm"
                    :class="errors.account_type ? 'is-invalid' : ''">
                </v-select>
                <small class="invalid-feedback" v-for="(error, index) in errors.account_type" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group mb-2" v-if="data.account_type == 2">
                <small class="input-title">Nombre de la Empresa</small>
                <input type="text" class="form-control form-control-sm" v-model="data.company" :class="errors.company ? 'is-invalid' : ''">
                <small class="invalid-feedback" v-for="(error, index) in errors.company" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2" v-if="data.account_type != 2">
                <small class="input-title">Nombre</small>
                <input type="text" class="form-control form-control-sm" v-model="data.first_name" :class="errors.first_name ? 'is-invalid' : ''">
                <small class="invalid-feedback" v-for="(error, index) in errors.first_name" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2" v-if="data.account_type != 2">
                <small class="input-title">Apellido</small>
                <input type="text" class="form-control form-control-sm" v-model="data.last_name" :class="errors.last_name ? 'is-invalid' : ''">
                <small class="invalid-feedback" v-for="(error, index) in errors.last_name" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2" v-if="(data.role ? data.role.name == 'warehouses' : false)">
                <small class="input-title">Bodega</small>
                <v-select v-model="data.warehouse_id" :items="warehouses" :item-text="(item) => item.code + '-' + item.name" item-value="id"
                    hide-details no-data class="form-control form-control-sm"
                    :class="errors.warehouse_id ? 'is-invalid' : ''">
                </v-select>  
                <small class="invalid-feedback" v-for="(error, index) in errors.warehouse_id" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2" v-if="(data.role ? data.role.name != 'customers' && data.role.name != 'drivers' : false)">
                <small class="input-title">Sucursal de entrega</small>
                <v-select v-model="data.deliver_branch_office" :items="branch_offices" item-text="name" item-value="id"
                    hide-details no-data class="form-control form-control-sm"
                    :class="errors.deliver_branch_office ? 'is-invalid' : ''">
                </v-select>  
                <small class="invalid-feedback" v-for="(error, index) in errors.deliver_branch_office" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2">
                <small class="input-title">Correo Electrónico</small>
                <input type="email" class="form-control form-control-sm" v-model="data.email" :class="errors.email ? 'is-invalid' : ''">
                <small class="invalid-feedback" v-for="(error, index) in errors.email" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2">
                <small class="input-title">Código</small>
                <input type="text" readonly class="form-control form-control-sm" :value="data.type+data.id">
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2">
                <small class="input-title">Genero</small>
                <v-select v-model="data.gender"
                    :items="genders"
                    hide-details
                    class="form-control form-control-sm"
                    :class="errors.gender ? 'is-invalid' : ''">
                </v-select>
                <small class="invalid-feedback" v-for="(error, index) in errors.gender" :key="index">{{ error }}</small>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    props: ['data', 'errors'],
    computed: {
        ...mapGetters([
            'accounts',
        ]),
    },
    data(){
        return{
            genders: [
                { value: null, text: 'Otro' },
                { value: 0, text: 'Masculino' },
                { value: 1, text: 'Femenino' }
            ],
            warehouses: [],
            branch_offices: [],
        }
    },
    created(){
        let vue = this
        vue.WAREHOUSES()
        vue.BRANCH_OFFICES()
    },
    methods: {
        WAREHOUSES: function(){
            let vue = this
            axios({url: 'all/warehouses', method: 'GET' })
            .then((resp) => {
                vue.warehouses = resp.data
            })
        },
        BRANCH_OFFICES: function(){
            let vue = this
            axios({url: '/all/branch-offices', method: 'GET' })
            .then((resp) => {
                vue.branch_offices = resp.data
            })
        },
    }
}
</script>